export default __webpack_public_path__ + "static/media/k_wdt_c_1.6fb7cfd1.mp3";